import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { EnqueteService } from '~/shared/service/enquete.service';
import { MainStore } from '~/store/index';
var EnqueteModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(EnqueteModule, _VuexModule);
  var _super = _createSuper(EnqueteModule);
  function EnqueteModule() {
    var _this;
    _classCallCheck(this, EnqueteModule);
    _this = _super.apply(this, arguments);
    _this.soTyperingen = [];
    _this.currentUserInformation = {};
    return _this;
  }
  _createClass(EnqueteModule, [{
    key: "setSOTyperingen",
    value: function setSOTyperingen(soTyperingenFromBackEnd) {
      this.soTyperingen = soTyperingenFromBackEnd;
    }
  }, {
    key: "setCurrentUserInformation",
    value: function setCurrentUserInformation(currentUserInformation) {
      this.currentUserInformation = currentUserInformation;
    }
  }, {
    key: "getSoTyperingen",
    value: function () {
      var _getSoTyperingen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return EnqueteService.GetTyperingen();
            case 2:
              response = _context.sent;
              this.setSOTyperingen(response);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSoTyperingen() {
        return _getSoTyperingen.apply(this, arguments);
      }
      return getSoTyperingen;
    }()
  }, {
    key: "GetSurveyInformation",
    value: function () {
      var _GetSurveyInformation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return EnqueteService.GetSurveyInformation(token);
            case 2:
              response = _context2.sent;
              this.setCurrentUserInformation(response);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function GetSurveyInformation(_x) {
        return _GetSurveyInformation.apply(this, arguments);
      }
      return GetSurveyInformation;
    }()
  }]);
  return EnqueteModule;
}(VuexModule);
__decorate([Mutation], EnqueteModule.prototype, "setSOTyperingen", null);
__decorate([Mutation], EnqueteModule.prototype, "setCurrentUserInformation", null);
__decorate([Action], EnqueteModule.prototype, "getSoTyperingen", null);
__decorate([Action], EnqueteModule.prototype, "GetSurveyInformation", null);
EnqueteModule = __decorate([Module({
  namespaced: true,
  name: 'EnqueteModule',
  dynamic: true,
  store: MainStore
})], EnqueteModule);
export default EnqueteModule;